import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from 'mlb-icons/json/iconsbyIds.json'; // eslint-disable-line import/no-extraneous-dependencies

var iconCount = 0;
var iconNames = Object.keys(icons);
var FALLBACK_ICON = icons.baseball;
function findIcon(name) {
  var lowercaseName = name.toLowerCase();
  var icon = iconNames.filter(function (name) {
    return name === lowercaseName;
  });
  if (icon.length > 1) {
    throw new Error('More than one icon was found with same name');
  }
  return icon.length === 0 ? FALLBACK_ICON : icons[icon];
}
function buildSvg() {
  var iconData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var svgElements = iconData.map(function (prop, index) {
    var key = index;
    if (prop.name === 'path') {
      return /*#__PURE__*/React.createElement("path", _extends({}, prop.attributes, {
        key: "path-".concat(key)
      }));
    } else if (prop.name === 'circle') {
      return /*#__PURE__*/React.createElement("circle", _extends({}, prop.attributes, {
        key: "circle-".concat(key)
      }));
    } else if (prop.name === 'rect') {
      return /*#__PURE__*/React.createElement("rect", _extends({}, prop.attributes, {
        key: "rect-".concat(key)
      }));
    } else if (prop.name === 'ellipse') {
      return /*#__PURE__*/React.createElement("ellipse", _extends({}, prop.attributes, {
        key: "ellipse-".concat(key)
      }));
    } else if (prop.name === 'g') {
      return /*#__PURE__*/React.createElement("g", _extends({}, prop.attributes, {
        key: "g-".concat(key)
      }), buildSvg(prop.children));
    } else {
      return null;
    }
  });
  return svgElements;
}
var Icon = function Icon(props) {
  var _classNames, _classNames2;
  var sizeNm = 16;
  switch (props.size) {
    case 'sm':
      sizeNm = 12;
      break;
    case 'md':
      sizeNm = 16;
      break;
    case 'lg':
      sizeNm = 24;
      break;
  }
  var icon = findIcon(props.icon);
  var content = buildSvg(icon.children);
  var _icon$attributes = icon.attributes,
    attributes = _icon$attributes === void 0 ? {} : _icon$attributes;
  var iconProps = {
    height: sizeNm,
    width: sizeNm,
    name: props.name,
    viewBox: attributes.viewBox,
    role: props.role || 'img',
    'aria-label': props.ariaLabel,
    'aria-labelledby': "title-".concat(icon.id, "-").concat(iconCount, " desc-").concat(icon.id, "-").concat(iconCount)
  };
  var iconTitleProps = {
    id: "title-".concat(icon.id, "-").concat(iconCount)
  };
  var iconDescProps = {
    id: "desc-".concat(icon.id, "-").concat(iconCount)
  };
  iconCount++;
  return /*#__PURE__*/React.createElement("svg", _extends({}, iconProps, {
    className: props.customColor ? classNames((_classNames = {
      'p-icon': true
    }, _defineProperty(_classNames, "p-icon--".concat(props.icon), true), _defineProperty(_classNames, "p-icon--".concat(props.size), props.size), _defineProperty(_classNames, props.className, props.className), _classNames)) : classNames((_classNames2 = {
      'p-og-icon': true
    }, _defineProperty(_classNames2, "p-og-icon--".concat(props.icon), true), _defineProperty(_classNames2, "p-og-icon--".concat(props.size), props.size), _defineProperty(_classNames2, props.className, props.className), _classNames2)),
    style: props.style
  }), /*#__PURE__*/React.createElement("title", iconTitleProps, icon.title), /*#__PURE__*/React.createElement("desc", iconDescProps, icon.title), content);
};
Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  //String. See icon pattern.
  className: PropTypes.string,
  //String. Valid HTML class attribute
  customColor: PropTypes.bool,
  size: PropTypes.oneOf(['md', 'sm', 'lg']),
  name: PropTypes.string,
  role: PropTypes.string,
  ariaLabel: PropTypes.string,
  // eslint-disable-next-line
  style: PropTypes.object //Passes through to svg style prop.
};
Icon.defaultProps = {
  icon: '',
  className: undefined,
  customColor: true,
  size: undefined,
  name: undefined
};
export default Icon;